import React from 'react';
import './utils/fetchWithRetry'; // Override global fetch for first call retry
import { CustomNotFoundPage } from './components/catalog/CustomNotFoundPage';
import { CustomErrorPage } from './components/catalog/CustomErrorPage';
import { GlobalErrorBoundary } from './components/ErrorBoundary/GlobalErrorBoundary';
import { Navigate, Route } from 'react-router-dom';
import { apiDocsPlugin, ApiExplorerPage } from '@backstage/plugin-api-docs';
// import { settingsPage } from './components/settings/SettingsPage';
import { FraudulantEmailPage } from '@internal/plugin-fraudulant-email';
import {
  CatalogEntityPage,
  CatalogIndexPage,
  catalogPlugin,
} from '@backstage/plugin-catalog';
import { FinanceReportingPage } from '@internal/backstage-plugin-finance-reporting';
import { PendingApprovalsProvider } from './hooks/useApprovals';
import RegisterComponentPage from './components/catalog/RegisterComponentPage';
import { HeaderVisibilityProvider } from './components/Root/HeaderVisibilityContext';
import { UnifiedThemeProvider } from '@backstage/theme';
import { ScriptDonwloadPage } from '@internal/plugin-script-donwload';
import { myTheme2 } from './themes/themes';
import {
  CatalogImportPage,
  catalogImportPlugin,
} from '@backstage/plugin-catalog-import';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { orgPlugin } from '@backstage/plugin-org';
import { SearchPage } from '@backstage/plugin-search';
import {
  TechDocsIndexPage,
  techdocsPlugin,
  TechDocsReaderPage,
} from '@backstage/plugin-techdocs';
// import { UserSettingsPage } from '@backstage/plugin-user-settings';
import { apis } from './apis';
import { entityPage } from './components/catalog/EntityPage';
import { searchPage } from './components/search/SearchPage';
import { Root } from './components/Root';
// import { HomePage } from '@internal/plugin-home-page/src/components/home-page';
import { HomePage } from '@internal/plugin-home-page';
// import { ContactUsPage } from './components/contactus/ContactUsPage';
// import { AboutPage } from './components/about/AboutUsPage';
import { oktaAuthApiRef } from '@backstage/core-plugin-api';
import {
  AlertDisplay,
  OAuthRequestDialog,
  SignInPage,
} from '@backstage/core-components';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph';
// import { FileUploadPage } from 'backstage-plugin-file-upload';
// import { CustomTechRadarPage } from '@internal/plugin-tech-radar';
import { RequirePermission } from '@backstage/plugin-permission-react';
import {
  AccessDeniedPage,
  // STSAccessPage,
  RBACPage,
  ApprovalsPage,
} from '@internal/plugin-request-access-page';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import {
  approvalsPermission,
  // stsProvisioningPermission,
  // stsOperationsPermission,
  // stsAdminPermission,
  superUserPermission,
  aiAgentPermission,
  logAnalyzerPermission,
  dxPagePermission,
  finopsPagePermission,
  financePagePermission,
} from '@internal/plugin-permissions-common-common';
// import { RpaPage } from '@internal/backstage-plugin-rpa';
import { AgentChatRouter } from '@internal/backstage-plugin-agent-chat';
import { AgentAdminPage } from '@internal/backstage-plugin-agent-chat';
// import { AmericanAirlinesPage } from '@internal/backstage-plugin-american-airlines';
// import { OverviewPagePage } from '@internal/backstage-plugin-overview-page';
// import { TemplatePagePage } from '@internal/backstage-plugin-overview-page';
import { UserMetricsPage } from '@internal/backstage-plugin-user-metrics';
import { CreateNewComponentPagePage } from '@internal/plugin-create-new-component-page';
import {
  GlobalHeader,
  DevHubPage,
} from '@internal/backstage-plugin-global-header';
import { TabSectionContext } from '@internal/backstage-plugin-global-header/src/contexts/TabSectionContext';
// --- STS imports (preserved, commented out while /sts routes show BishopMigrationPage) ---
// import { ScaffolderPage } from '@backstage/plugin-scaffolder';
// import {
//   ScaffolderFieldExtensions,
//   ScaffolderLayouts,
// } from '@backstage/plugin-scaffolder-react';
// import { InfrastructureStatusPage } from '@internal/plugin-infrastructure-status';
// import { CustomScaffolderPagePage } from '@internal/backstage-plugin-custom-scaffolder-page';
// import { InfrastructureStatsPage } from '@internal/backstage-plugin-infrastructure-stats';
// import { FinanceReportingPage } from '@internal/backstage-plugin-finance-reporting';
// import { JsonOrFormInputFieldExtension } from './scaffolder/JsonOrFormInput';
// import { TemplatePlayground } from './components/TemplatePlayground/TemplatePlayground';
// import { ScaffolderModalWrapper } from './scaffolder/ScaffolderModalWrapper';
// import { CustomTemplateOutputs } from './scaffolder/CustomTemplateOutputs';
// import { CustomOngoingTask } from './scaffolder/CustomOngoingTask';
// import { useAgentChatTemplateInfo } from './components/Root/STSNavItem';
// import { useApi } from '@backstage/core-plugin-api';
// import { catalogApiRef } from '@backstage/plugin-catalog-react';
// import { useAsync } from 'react-use';
// import { Progress } from '@backstage/core-components';
// import { N8NStatusPage } from '@internal/backstage-plugin-n8n-status';
import { OnboardingPage } from '@internal/plugin-onboarding-page';
import { BishopMigrationPage } from './components/sts/BishopMigrationPage';
import { FinOpsDashboardPage } from '@internal/backstage-plugin-finops';

import { Box } from '@material-ui/core';
import { Breadcrumbs } from '@internal/backstage-plugin-global-header';

/*
const ScaffolderListGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const isListPath =
    /^\/sts\/(infra-provisioning|operations)\/[^/]+(\/)?\.?$/.test(pathname);
  if (!isListPath) return <CustomNotFoundPage />;
  return <>{children}</>;
};

const ScaffolderCreateGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname, state } = useLocation() as { pathname: string; state: any };
  const isTemplateOrTask = /\/(templates|tasks)\//.test(pathname);
  if (!isTemplateOrTask)
    return pathname === '/sts/create' || pathname === '/sts/create/' ? (
      <Navigate to={state?.from ?? '/sts/infrastructure-stats'} replace />
    ) : (
      <CustomNotFoundPage />
    );
  return <>{children}</>;
};

const STSRouteGuard = ({
  permission,
  children,
}: {
  permission: typeof stsProvisioningPermission;
  children: React.ReactNode;
}) => (
  <RequirePermission permission={permission} errorPage={<STSAccessPage />}>
    {children}
  </RequirePermission>
);

const makeListRoute = (path: string, filterTag: string) => (
  <Route
    path={path}
    element={
      <ScaffolderListGuard>
        <CustomScaffolderPagePage filterTag={filterTag} />
      </ScaffolderListGuard>
    }
  />
);

const TAG_PERMISSION_MAP: Record<string, typeof stsProvisioningPermission> = {
  aws: stsProvisioningPermission,
  azure: stsProvisioningPermission,
  gcp: stsProvisioningPermission,
  'on-premises': stsProvisioningPermission,
  'patch-management': stsOperationsPermission,
  'change-management': stsOperationsPermission,
  linux: stsOperationsPermission,
  windows: stsOperationsPermission,
};

const AgentTemplateGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const { tags, loading } = useAgentChatTemplateInfo();
  const templateName = pathname.match(/\/sts\/agent-chat\/[^/]+\/([^/]+)/)?.[1];

  if (loading) return <Progress />;
  if (pathname.includes('/sts/agent-chat/admin'))
    return (
      <RequirePermission
        permission={superUserPermission}
        errorPage={<STSAccessPage hideRequestAccess />}
      >
        {children}
      </RequirePermission>
    );
  if (!templateName) return <CustomNotFoundPage />;
  const permission = tags.reduce<typeof stsProvisioningPermission | undefined>(
    (found, tag) => found ?? TAG_PERMISSION_MAP[tag],
    undefined,
  );
  if (permission)
    return <STSRouteGuard permission={permission}>{children}</STSRouteGuard>;
  return <>{children}</>;
};

const TemplateGuard = ({ children }: { children: React.ReactNode }) => {
  const catalogApi = useApi(catalogApiRef);
  const { pathname } = useLocation();
  const match = pathname.match(/\/create\/templates\/([^/]+)(?:\/([^/]+))?/);

  const { value, loading } = useAsync(async () => {
    if (!match) return { exists: true, permission: undefined };
    const [, namespace, templateName] = match;
    if (!templateName) return { exists: false, permission: undefined };
    try {
      const entity = await catalogApi.getEntityByRef(
        `template:${namespace}/${templateName}`,
      );
      if (!entity) return { exists: false, permission: undefined };
      const tags = entity.metadata?.tags ?? [];
      const permission = tags.reduce<
        typeof stsProvisioningPermission | undefined
      >((found, tag) => found ?? TAG_PERMISSION_MAP[tag], undefined);
      return { exists: true, permission };
    } catch {
      return { exists: false, permission: undefined };
    }
  }, [match?.[0]]);

  if (loading) return <Progress />;
  if (!value?.exists) return <CustomNotFoundPage />;
  if (value.permission)
    return (
      <STSRouteGuard permission={value.permission}>{children}</STSRouteGuard>
    );
  return <>{children}</>;
};
*/

const app = createApp({
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: false,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: false,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: false,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
  components: {
    NotFoundErrorPage: CustomNotFoundPage,
    ErrorBoundaryFallback: CustomErrorPage,
    SignInPage: props => (
      <SignInPage
        {...props}
        providers={[
          // 'guest',
          {
            id: 'github-auth-provider',
            title: 'Okta',
            message: 'Sign in using okta',
            apiRef: oktaAuthApiRef,
          },
        ]}
      />
    ),
  },
  themes: [
    {
      id: 'my-theme',
      title: 'My Custom Theme',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={myTheme2}>{children}</UnifiedThemeProvider>
      ),
    },
  ],
});

const FinOpsRoute = ({ children }: { children: React.ReactNode }) => (
  <RequirePermission
    permission={finopsPagePermission}
    errorPage={<AccessDeniedPage />}
  >
    {children}
  </RequirePermission>
);

const routes = (
  <FlatRoutes>
    <Route path="/" element={<Navigate to="/marketplace/home" />} />
    <Route path="/sts" element={<BishopMigrationPage />} />
    <Route path="/sts/*" element={<BishopMigrationPage />} />
    <Route
      path="/marketplace/docs/catalog"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <CatalogIndexPage />
        </>
      }
    />
    <Route
      path="/marketplace/docs/catalog/:namespace/:kind/:name"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <CatalogEntityPage />
        </>
      }
    >
      {entityPage}
    </Route>
    {/* <Route path="/marketplace/tech-radar" element={<CustomTechRadarPage />} /> */}
    {/* <Route path="/contact-us" element={<ContactUsPage />} />
    <Route path="/about" element={<AboutPage />} /> */}

    <Route
      path="/marketplace/docs"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <TechDocsIndexPage />
        </>
      }
    />
    <Route
      path="/marketplace/docs/:namespace/:kind/:name/*"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <TechDocsReaderPage />
        </>
      }
    >
      {/* <TechDocsAddons>
        <ReportIssue />
      </TechDocsAddons> */}
    </Route>
    <Route
      path="/marketplace/create"
      element={
        // <ScaffolderPage
        //   templateFilter={entity =>
        //     entity?.metadata?.tags?.includes('dont remove') ?? false
        //   }
        // />
        <CreateNewComponentPagePage />
      }
    />
    <Route
      path="/marketplace/docs/api-docs"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <ApiExplorerPage />
        </>
      }
    />

    <Route
      path="/marketplace/create/catalog-import"
      element={
        <RequirePermission
          permission={catalogEntityCreatePermission}
          errorPage={<AccessDeniedPage />}
        >
          <CatalogImportPage />
        </RequirePermission>
      }
    >
      <RegisterComponentPage />
    </Route>

    <Route path="/marketplace/search" element={<SearchPage />}>
      {searchPage}
    </Route>
    {/* <Route path="/settings" element={<UserSettingsPage />} /> */}
    {/* <Route path="/settings" element={<UserSettingsPage />}>
      {settingsPage}
    </Route> */}
    <Route
      path="/marketplace/docs/catalog-graph"
      element={
        <>
          <Box style={{ padding: '24px 24px 0 24px' }}>
            <Breadcrumbs />
          </Box>
          <CatalogGraphPage />
        </>
      }
    />
    <Route
      path="/marketplace/approvals"
      element={
        <RequirePermission permission={approvalsPermission}>
          <ApprovalsPage />
        </RequirePermission>
      }
    />
    {/* <Route
      path="/sts/approvals"
      element={
        <RequirePermission
          permission={stsPagePermission}
          errorPage={<AccessDeniedPage />}
        >
          <RequirePermission permission={approvalsPermission}>
            <ApprovalsPage />
          </RequirePermission>
        </RequirePermission>
      }
    /> */}
    <Route path="/marketplace/request-access" element={<RBACPage />} />
    {/* <Route
      path="/sts/request-access"
      element={
        <RequirePermission
          permission={stsPagePermission}
          errorPage={<AccessDeniedPage />}
        >
          <RBACPage />
        </RequirePermission>
      }
    /> */}
    <Route
      path="/marketplace/fraudulant-email-check"
      element={<FraudulantEmailPage />}
    />
    <Route
      path="/marketplace/script-download"
      element={<ScriptDonwloadPage />}
    />
    <Route path="/marketplace/home" element={<HomePage />} />
    <Route path="/marketplace/dev-hub" element={<DevHubPage />} />
    <Route path="/marketplace" element={<Navigate to="/marketplace/home" />} />
    <Route
      path="/marketplace/fraudulant-email"
      element={<FraudulantEmailPage />}
    />
    <Route path="/marketplace/user-metrics" element={<UserMetricsPage />} />
    <Route path="/finops" element={<Navigate to="/finops/dashboard" />} />
    <Route
      path="/marketplace/onboarding"
      element={
        <RequirePermission
          permission={superUserPermission}
          errorPage={<AccessDeniedPage hideRequestAccess />}
        >
          <OnboardingPage />
        </RequirePermission>
      }
    />
    {/* <Route path="/marketplace/automation-processes" element={<RpaPage />} /> */}
    <Route
      path="/marketplace/home/agent-chat/admin"
      element={
        <RequirePermission
          permission={superUserPermission}
          errorPage={<AccessDeniedPage hideRequestAccess />}
        >
          <AgentAdminPage
            namespace="aicoe_marketplace"
            backPath="/marketplace/home/agent-chat"
          />
        </RequirePermission>
      }
    />
    <Route
      path="/marketplace/home/agent-chat/aicoe_marketplace_log_analyzer/*"
      element={
        <RequirePermission
          permission={logAnalyzerPermission}
          errorPage={<AccessDeniedPage />}
        >
          <AgentChatRouter
            namespace="aicoe_marketplace"
            backPath="/marketplace"
            basePath="/marketplace/home/agent-chat"
            defaultAgent="aicoe_marketplace_log_analyzer"
          />
        </RequirePermission>
      }
    />
    <Route
      path="/marketplace/home/agent-chat/aicoe_marketplace_ai_search/*"
      element={
        <RequirePermission
          permission={aiAgentPermission}
          errorPage={<AccessDeniedPage />}
        >
          <AgentChatRouter
            namespace="aicoe_marketplace"
            backPath="/marketplace"
            basePath="/marketplace/home/agent-chat"
            defaultAgent="aicoe_marketplace_ai_search"
          />
        </RequirePermission>
      }
    />

    {/* --- Original STS routes (preserved, commented out — all /sts/* now show BishopMigrationPage) --- */}
    {/* <Route
      path="/sts/agent-chat/*"
      element={
        <AgentTemplateGuard>
          <AgentChatRouter
            namespace="sts"
            backPath="/sts"
            basePath="/sts/agent-chat"
            showAgentsSidebar={false}
            stsMode
            useSTSLayout
          />
        </AgentTemplateGuard>
      }
    /> */}
    {/* <Route
      path="/marketplace/confluence-workflow"
      element={<AmericanAirlinesPage />}
    /> */}
    {/* <Route path="/overview-page" element={<OverviewPagePage />} /> */}
    {/* <Route path="/template" element={<TemplatePagePage />} /> */}
    {/* <Route
      path="/sts/infra-provisioning/aws"
      element={
        <div className="infrastructure-page-wrapper">
          <ScaffolderPage
            templateFilter={entity =>
              entity?.metadata?.tags?.includes('infrastructure') ?? false
            }
            headerOptions={{ pageTitleOverride: '', title: '', subtitle: '' }}
          />
        </div>
      }
    /> */}
    {/* <Route
      path="/sts/task-dashboard"
      element={<InfrastructureStatusPage />}
    />
    <Route path="/sts/infra-provisioning" element={<Navigate to="/sts/infra-provisioning/aws" replace />} />
    <Route path="/sts/operations" element={<Navigate to="/sts/operations/patch-management" replace />} />
    {makeListRoute('/sts/infra-provisioning/aws',         'aws')}
    {makeListRoute('/sts/infra-provisioning/azure',       'azure')}
    {makeListRoute('/sts/infra-provisioning/gcp',         'gcp')}
    {makeListRoute('/sts/infra-provisioning/on-premises', 'on-premises')}
    {makeListRoute('/sts/operations/patch-management', 'patch-management')}
    {makeListRoute('/sts/operations/change-management', 'change-management')}
    {makeListRoute('/sts/operations/linux', 'linux')}
    {makeListRoute('/sts/operations/windows', 'windows')}
    <Route
      path="/sts/create"
      element={
        <ScaffolderCreateGuard>
          <TemplateGuard>
            <ScaffolderModalWrapper>
              <ScaffolderPage
                formProps={{ showErrorList: false } as any}
                components={{
                  EXPERIMENTAL_TemplateOutputsComponent: CustomTemplateOutputs,
                  TaskPageComponent: CustomOngoingTask,
                }}
              />
            </ScaffolderModalWrapper>
          </TemplateGuard>
        </ScaffolderCreateGuard>
      }
    >
      <ScaffolderFieldExtensions>
        <JsonOrFormInputFieldExtension />
      </ScaffolderFieldExtensions>
      <ScaffolderLayouts />
    </Route>
    <Route
      path="/sts/infrastructure-stats"
      element={<InfrastructureStatsPage />}
    />
    <Route
      path="/sts/lifecycle-management"
      element={<LifecycleManagementPage />}
    />
    <Route path="/sts/playground" element={<TemplatePlayground />} /> */}
    <Route
      path="/finops/dashboard"
      element={
        <FinOpsRoute>
          <FinOpsDashboardPage />
        </FinOpsRoute>
      }
    />
    <Route
      path="/finops/bu-insights"
      element={
        <FinOpsRoute>
          <FinOpsDashboardPage />
        </FinOpsRoute>
      }
    />
    <Route
      path="/finops/anomalies"
      element={
        <FinOpsRoute>
          <FinOpsDashboardPage />
        </FinOpsRoute>
      }
    />
    <Route
      path="/finops/chargeback"
      element={
        <FinOpsRoute>
          <FinOpsDashboardPage />
        </FinOpsRoute>
      }
    />
    <Route
      path="/finops/ai-tools"
      element={
        <FinOpsRoute>
          <FinOpsDashboardPage />
        </FinOpsRoute>
      }
    />
    <Route path="/creative" element={<Navigate to="/creative/home" />} />
    <Route path="/creative/home" element={<HomePage tabId="creative" />} />
    {/* <Route path="/sts/*" element={<CustomNotFoundPage />} /> */}
    <Route
      path="/finance"
      element={<Navigate to="/finance/reporting" replace />}
    />
    <Route
      path="/finance/home"
      element={<Navigate to="/finance/reporting" replace />}
    />
    <Route
      path="/finance/reporting"
      element={
        <RequirePermission
          permission={financePagePermission}
          errorPage={<AccessDeniedPage hideRequestAccess />}
        >
          <FinanceReportingPage />
        </RequirePermission>
      }
    />
    <Route path="/dx" element={<Navigate to="/dx/home" />} />
    <Route
      path="/dx/home"
      element={
        <RequirePermission
          permission={dxPagePermission}
          errorPage={<AccessDeniedPage />}
        >
          <HomePage tabId="dx" />
        </RequirePermission>
      }
    />
    <Route path="/media" element={<Navigate to="/media/home" />} />
    <Route path="/media/home" element={<HomePage tabId="media" />} />
    {/* <Route path="/n8n" element={<Navigate to="/n8n/workflows" />} /> */}
    {/* <Route
      path="/sts/executions"
      element={
        <RequirePermission
          permission={stsOperationsPermission}
          errorPage={<STSAccessPage />}
        >
          <N8NStatusPage />
        </RequirePermission>
      }
    /> */}
    {/* <Route
      path="/n8n/workflows/*"
      element={<N8NWorkflowsPage />}
    /> */}
  </FlatRoutes>
);

const TabSectionProviderWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [activeSection, setActiveSection] = React.useState<
    | 'marketplace'
    | 'finops'
    | 'sts'
    | 'creative'
    | 'finance'
    | 'media'
    | 'dx'
    | 'n8n'
  >('marketplace');

  return (
    <TabSectionContext.Provider value={{ activeSection, setActiveSection }}>
      {children}
    </TabSectionContext.Provider>
  );
};

export default app.createRoot(
  <PendingApprovalsProvider>
    <TabSectionProviderWrapper>
      <AlertDisplay />
      <OAuthRequestDialog />
      <AppRouter>
        <GlobalHeader>
          <HeaderVisibilityProvider>
            <Root>
              <GlobalErrorBoundary>{routes}</GlobalErrorBoundary>
            </Root>
          </HeaderVisibilityProvider>
        </GlobalHeader>
      </AppRouter>
    </TabSectionProviderWrapper>
  </PendingApprovalsProvider>,
);
